export default class SuccessScoringReasonDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), modifiedDate: new Date(json.modifiedDate) });
    }
}
